"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsLevelFactory = (options) => {
    switch (options.level) {
        case "DEBUG":
            return (level) => level === "DEBUG" ||
                level === "INFO" ||
                level === "WARN" ||
                level === "ERROR";
        case "INFO":
            return (level) => level === "INFO" ||
                level === "WARN" ||
                level === "ERROR";
        case "WARN":
            return (level) => level === "WARN" || level === "ERROR";
        case "ERROR":
            return (level) => level === "ERROR";
    }
};
//# sourceMappingURL=supportsLevelFactory.js.map